/* tslint:disable */
/* eslint-disable */
/**
 * supportWebappContactForm support-contact-form api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

export const UserPersona = {
        RIDER: 'rider',
        SCOOTERS: 'scooter_rider',
        EBIKE: 'ebike_rider',
        CAR_RENTAL: 'car_rental_user',
        LONGTERM_CAR_RENTAL: 'longterm_car_rental',
        EATER: 'eater',
        DRIVER: 'driver',
        DRIVER_LEAD: 'driver_lead',
        COURIER: 'courier',
        PROVIDER: 'provider',
        AUTHORITY: 'authority',
        AUTHORITY_RIDES: 'authority_rides',
        AUTHORITY_DRIVE: 'authority_drive',
        AUTHORITY_DELIVERY: 'authority_delivery',
        AUTHORITY_MICROMOBILITY: 'authority_micromobility',
        THIRD_PARTY_RIDES: 'third_party_rides',
        THIRD_PARTY_DRIVE: 'third_party_drive',
        THIRD_PARTY_DELIVERY: 'third_party_delivery',
        THIRD_PARTY_MICROMOBILITY: 'third_party_micromobility',
        MARKET_CONSUMER: 'market_consumer',
        FLEET_OWNER: 'fleet_owner',
        BUSINESS_ADMIN: 'business_admin',
        BUSINESS_COMPANY: 'business_company',
        COURIER_LEAD: 'courier_lead',
        COURIER_FLEET_OWNER: 'courier_fleet_owner',
        UNCLASSIFIED: 'unclassified',
        DRIVE_FLEET_OWNER: 'drive_fleet_owner',
        EBIKE_FLEET_OWNER: 'ebike_fleet_owner',
        PROVIDER_LEAD: 'provider_lead',
        CARDS_ADMIN: 'cards_admin',
        CARD_USER: 'card_user',
        PAYMENT_PROVIDER: 'payment_provider',
        LUX_CLIENT: 'lux_client',
        LUX_CHAUFFEUR: 'lux_chauffeur',
        LUX_FLEET: 'lux_fleet',
        LUX_BOOKER: 'lux_booker',
        RIDE_BOOKER: 'ride_booker',
        BOLT_SEND_SENDER: 'bolt_send_sender',
        BOLT_SEND_RECEIVER: 'bolt_send_receiver'
} as const;
export type UserPersona = typeof UserPersona[keyof typeof UserPersona];

